export default {
  download: (response, filename, type) => {
    if (type === undefined) {
      type = "text/csv";
    }

    const element = document.createElement("a");
    const file = new Blob([response.data ? response.data : response], { type });
    element.href = window.URL.createObjectURL(file);
    element.target = "_self";
    element.download = filename;
    element.click();
  },
};
